import { render, staticRenderFns } from "./searchArrivals.vue?vue&type=template&id=70d787c7&scoped=true"
import script from "./searchArrivals.vue?vue&type=script&lang=js"
export * from "./searchArrivals.vue?vue&type=script&lang=js"
import style0 from "./searchArrivals.vue?vue&type=style&index=0&id=70d787c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d787c7",
  null
  
)

export default component.exports